export const QA = 'qa';
export const TIME_BASED = 'time_based';



// WEBPACK FOOTER //
// ./src/constants/quotaType.js